// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__v1VSk","large":"styles_large__2lJU-"};